export const refuelingService = () => {
  return {
    carouselItems: [
      {
        lottie: '/json/refueling-tutorial01.json',
        content:
          '前往麻吉付加油站，加油前，與加油員喊聲「我要用麻吉付」與統編。',
      },
      {
        lottie: '/json/refueling-tutorial02.json',
        content: '開啟加油授權付款畫面，點擊「同意付款」完成。',
      },
      {
        lottie: '/json/refueling-tutorial03.json',
        content: '加油完成，部分加油站發票自動存入設定載具，現場免拿發票。',
      },
    ],
  };
};

export const refuelingPassService = () => {
  return {
    carouselItems: [
      {
        lottie: '/json/refueling-pass-tutorial01.json',
        content: '申請開通快速通，等待車牌綁定完成。',
      },
      {
        lottie: '/json/refueling-pass-tutorial02.json',
        content:
          '前往快速通加油站，加油前，與加油員喊聲「我要用快速通」與統編。',
      },
      {
        lottie: '/json/refueling-pass-tutorial03.json',
        content: '加油完成，隔日扣款。現場開立發票，免簽單據。',
      },
    ],
  };
};

export const refuelingBarcodePaymentService = () => {
  return {
    carouselItems: [
      {
        lottie: '/json/barcode-payment-tutorial01.json',
        content:
          '前往條碼付加油站，於加油完成時，告知站員「我要用條碼付」與統編。 ',
      },
      {
        lottie: '/json/barcode-payment-tutorial02.json',
        content: '出示「條碼付款」畫面，掃描付款條碼與發票載具，完成付款。',
      },
      {
        lottie: '/json/barcode-payment-tutorial03.json',
        content: '發票將存入您掃描的載具，開立統編請現場索取發票。',
      },
    ],
  };
};

export const parkingService = () => {
  return {
    carouselItems: [
      {
        lottie: '/json/parking-tutorial01.json',
        content: '前往快速通停車場，車牌辨識進場，免取票卡。',
      },
      {
        lottie: '/json/parking-tutorial02.json',
        content: '進場後，即時追蹤停車時數與金額。（部分公有場不提供進場資訊）',
      },
      {
        lottie: '/json/parking-tutorial03.json',
        content:
          '出場時，車牌辨識自動付款，扣款結果即時通知。（使用商家消費折抵，請至繳費機付款）',
      },
    ],
  };
};
